import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EmptyState, PageHeader } from "@/components/ui";

/**
 * What the router renders for a path this build does not serve.
 *
 * Without it TanStack falls back to a bare "Not Found" string with no chrome
 * and no way onward — which is what a mistyped URL, a stale bookmark or a link
 * from an older build all land on. The action goes to the workspace root, which
 * resolves each persona to their own landing rather than guessing here.
 */
export function NotFound() {
  const { t } = useTranslation("company");
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-6xl space-y-6 p-4 sm:p-8">
      <PageHeader title={t("notFound.title")} subtitle={t("notFound.subtitle")} />
      <EmptyState
        title={t("notFound.empty.title")}
        description={t("notFound.empty.description")}
        actionLabel={t("notFound.empty.action")}
        onAction={() => {
          void navigate({ to: "/" });
        }}
      />
    </div>
  );
}
